<template>
    <div class="menu">
        <div v-for="(menu,index) in menuList" :key="index">
            <label>{{menu.title}}</label>
            <span
                v-for="(url,i) in menu.urlList"
                :key="i"
                @click="routerTo(url.to)"
            >{{url.name}}</span>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            menuList: [
                {
                    title: "预报预警",
                    urlList: [
                        { to: "/", name: "首府天气" },
                        { to: "/quanjiang", name: "全疆天气" },
                        { to: "/jingqu", name: "景区天气" },
                        { to: "/road", name: "公路预报" },
                        { to: "/warning", name: "预警信号" },
                        { to: "/city", name: "城市天气" }
                    ]
                },
                {
                    title: "综合观测",
                    urlList: [
                        { to: "/real", name: "天气实况" },
                        { to: "/realSort", name: "统计排名" },
                        { to: "/radar", name: "雷达监测" },
                        { to: "/weixing", name: "卫星云图" },
                        // { to: "/", name: "临近气象站" }
                    ]
                },
                {
                    title: "微服务",
                    urlList: [
                        { to: "/chuxing", name: "出行天气" },
                        // { to: "/", name: "实景图片" },
                        { to: "/weibo", name: "官方微博" },
                        { to: "/upload", name: "灾情反馈" },
                        { to: "/kepu", name: "气象科普" }
                    ]
                }
            ]
        };
    },
    methods: {
        routerTo(to) {
            const from = this.$route;
            this.$emit("url-change");
            if (from.path !== to) {
                this.$router.push(to);
            }
        }
    }
};
</script>

<style lang="less">
.menu {
    width: 100%;
    height: 100%;
    background-image: linear-gradient(#141e7a, #08a9bd);

    > div {
        color: white;
        padding: 20px;
        padding-bottom: 0;
        > label {
            display: block;
            padding-bottom: 5px;
            font-weight: bold;
            font-size: large;
            border-bottom: 1px solid rgba(218, 230, 230, 0.5);
        }
        > span {
            color: white;
            text-decoration: none;
            display: inline-block;
            padding: 5px;
            margin-top: 5px;
        }
    }
}
</style>